<template>
    <div class="box">
        <!--上传素材-->
        <Modal v-model="upload_dialog" :title="$t('MaterialManagement.Material.uploadDialog.title')">
            <Uploader ref="uploader"
                :uploadServer="uploadServer"
                :categoryId="id"
                :uploadType="filter.type"
                :maxSize="uploadMaxSize"
                :userId="topicUid"
                :resize="filter.type==3?3:0"
                >
                <div style="padding: 20px 0">
                    <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                    <p>{{ $t('MaterialManagement.Material.uploadDialog.prompt') }}</p>
                </div>
            </Uploader>
            <div slot="footer">
                <Button size="large" long @click="upload_dialog=false">{{ $t('Button.close') }}</Button>
            </div>
        </Modal>
        <!--编辑素材信息-->
        <Modal
            v-model="dialog"
            :title="$t('MaterialManagement.Material.editDialog.title')"
            :loading="dialog_loading"
            :mask-closable="false"
            @keydown.native.enter.prevent="save"
        >
            <Form :label-width="80">
                <FormItem :label="$t('MaterialManagement.Material.editDialog.name')" style="margin-bottom: 0">
                    <Input v-model="materialSettings.name" show-word-limit :maxlength="50"/>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="dialog=false">{{ $t('Button.cancel') }}</Button>
                <Button type="primary" size="large" @click="save">{{ $t('Button.confirm') }}</Button>
            </div>
        </Modal>
        <div class="header">
            <Row type="flex" class="toolbar">
                <Col span="24">
                    <Button
                        ref="upload_btn"
                        @click="showUploader"
                        icon="md-cloud-upload"
                        type="primary"
                    >{{ $t('MaterialManagement.Material.button.uploadMaterial') }}</Button>
                </Col>
            </Row>
            <div class="filter">
                <ul class="filter-box">
                    <li>
                        <span>{{ $t('MaterialManagement.Material.filter.name') }}</span>
                        <Input
                            class="selector"
                            v-model="filter.name"
                            size="small"
                            clearable
                            :placeholder="$t('Message.placeholder')"
                        />
                    </li>
                    <!--<li>
                        <span>{{ $t('MaterialManagement.Material.filter.type.title') }}</span>
                        <Select transfer class="selector" v-model="filter.type" size="small">
                            <Option :value="1">{{ $t('MaterialManagement.Material.filter.type.video') }}</Option>
                            <Option :value="2">{{ $t('MaterialManagement.Material.filter.type.audio') }}</Option>
                            <Option :value="3">{{ $t('MaterialManagement.Material.filter.type.image') }}</Option>
                        </Select>
                    </li>-->
                </ul>
                <Button 
                    class="refresh-button" 
                    type="primary" 
                    size="small"
                    @click="() => refresh()">
                    {{ $t('Button.refresh') }}
                </Button>
            </div>
        </div>
        <Preview v-model="show_player" :material="playerMaterial" />
        <PicturePreviewDialog v-model="show_viewer" :imageSrc="viewerMaterial" />
        <div ref="list" class="content">

            <ul class="list">
                <li
                    class="item"
                    :key="p.id"
                    v-for="p in list"
                >
                    <div class="item-thumb">
                        <PrettyImage
                                :src="imgSrc(p)"
                        />
                        <div class="view" @click.stop="showPreview(p)">
                            <Icon
                                :type="p.type == Const.Material.Type.Image?'ios-search':'ios-play'"
                                class="view-icon"
                                size="24"
                            />
                        </div>
                    </div>

                    <div class="item-info">
                        <span class="title">
                            <span class="title-tag">
                                <PrettyText :text="Const.Material.Type(p.type)" />
                            </span>
                            <span :title="p.name">&nbsp;{{p.name}}</span>
                            <span v-if="p.vrFlag == Const.Material.VRFlag.VR" style="margin:0 5px 0 2px;position:relative;top:-1px">
                                <svg id="VRMark" style="height: 16px; vertical-align: middle" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 385.62 151">
                                    <defs><svg:style>
                                        .cls-1{fill:#ffb354;} 
                                        #VRMark path{
                                            fill:#333;
                                            storke-width:0
                                        }
                                    </svg:style></defs>
                                    <title>vr</title>
                                    <rect class="cls-1" width="385.62" height="151" rx="50" ry="50"></rect>
                                    <path d="M171.69,125.07h-18.9A19.44,19.44,0,0,1,135,113.4l-2.07-4.73a7.63,7.63,0,0,0-14,0l-2.07,4.73A19.44,19.44,0,0,1,99,125.07H79.54A29.57,29.57,0,0,1,50,95.53V54.47A29.57,29.57,0,0,1,79.54,24.93h92.16a29.57,29.57,0,0,1,29.54,29.54V65.7a5.91,5.91,0,0,1-11.81,0V54.47a17.74,17.74,0,0,0-17.72-17.72H79.54A17.74,17.74,0,0,0,61.81,54.47V95.53a17.74,17.74,0,0,0,17.72,17.72H99a7.63,7.63,0,0,0,7-4.58l2.07-4.73a19.45,19.45,0,0,1,35.64,0l2.07,4.73a7.63,7.63,0,0,0,7,4.58h18.9a17.74,17.74,0,0,0,17.72-17.72,5.91,5.91,0,0,1,11.81,0A29.57,29.57,0,0,1,171.69,125.07Zm4.43-54.64A17.72,17.72,0,1,0,158.4,88.14,17.74,17.74,0,0,0,176.12,70.42Zm-11.81,0a5.91,5.91,0,1,1-5.91-5.91A5.91,5.91,0,0,1,164.31,70.42Zm-53.76,0A17.72,17.72,0,1,0,92.83,88.14,17.74,17.74,0,0,0,110.55,70.42Zm-11.81,0a5.91,5.91,0,1,1-5.91-5.91A5.91,5.91,0,0,1,98.74,70.42Z"></path><path d="M233.84,49.82h17.35l12.09,38.66,11.94-38.66h16.85l-19.95,53.72h-18Z"></path><path d="M297.71,103.54V49.82h27.67q7.69,0,11.76,1.32A12.52,12.52,0,0,1,343.7,56a14.84,14.84,0,0,1,2.49,8.7,14.36,14.36,0,0,1-7.15,13,20.07,20.07,0,0,1-5.83,2.13,16.61,16.61,0,0,1,4.32,2,16.77,16.77,0,0,1,2.65,2.83A20.94,20.94,0,0,1,342.51,88l8,15.57H331.8l-8.87-16.42a12.52,12.52,0,0,0-3-4.14,7,7,0,0,0-4.07-1.25h-1.47v21.8Zm16.67-32h7a25,25,0,0,0,4.4-.73,4.39,4.39,0,0,0,2.69-1.69,5.44,5.44,0,0,0-.61-7.11q-1.65-1.39-6.19-1.39h-7.29Z"></path>
                                </svg>
                            </span>
                        </span>
                        <ul class="list">
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.userName') }}</span>
                                <span class="content">
                                    {{p.userName}}
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.topicName') }}</span>
                                <span class="content">
                                    {{ p.topicName }}
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.status') }}</span>
                                <span class="content">
                                    <PrettyText :text="Const.Material.Status(p.status)" :type="p.type" />
                                    <span v-if="p.status == Const.Material.Status.Progress">- {{p.finishRate}}%</span>
                                </span>
                            </li>
                            <li v-if="globalConfig.mediaPublishFlag && config.materialPublish !== false">
                                <span class="title">{{ $t('MaterialManagement.Material.list.publishStatus') }}</span>
                                <span v-if="p.type == 1" class="content">
                                    <PrettyText :text="Const.Material.PublishStatus(p.publishStatus)" />
                                </span>
                                <span v-else class="content">
                                    {{ $t('Message.explainEmpty') }}
                                </span>
                            </li>
                            <li>
                                <span class="title">{{ $t('MaterialManagement.Material.list.createDatetime') }}</span>
                                <span class="content">{{ p.createDatetime }}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="item-op">
                        <Button
                            v-if="hasPermission('opMaterialInfo')"
                            class="download_btn"
                            type="text"
                            size="large"
                            icon="md-cloud-download"
                            style="margin-right: 5px"
                            @click="getDownload(p.id)"
                        >{{ $t('Button.download') }}</Button>
                        <Button
                                v-if="hasPermission('opMaterialInfo')"
                            class="edit_btn"
                            type="dashed"
                            size="large"
                            icon="md-settings"
                            @click="edit(p.id, p.name)"
                        >{{ $t('Button.edit') }}</Button>
                        <Button
                            v-if="hasPermission('opMaterialInfo') && globalConfig.mediaPublishFlag
                            && config.materialPublish !== false
                            && p.type == Const.Material.Type.Video &&  p.status == Const.Material.Status.Done"
                            :disabled="publishing(p.publishStatus)"
                            class="edit_btn"
                            type="dashed"
                            size="large"
                            icon="md-cloud-upload"
                            style="margin-left: 100px"
                            @click="publish(p.id, p.publishStatus)"
                        >{{ $t('Button.publish') }}</Button>
                        <Button
                                v-if="hasPermission('opMaterialInfo')"
                            class="delete_btn"
                            type="dashed"
                            size="large"
                            icon="md-close"
                            @click="remove(p.id,p.name)"
                        >{{ $t('Button.remove') }}</Button><!--&&(p.userId==userId||filter.selectType != 3)-->
                    </div>
                </li>
            </ul>

            <Spin v-show="loading" fix class="spin">
                <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
                <div>Loading</div>
            </Spin>
            <Page
                class="pager"
                :total="pagination.total"
                :current="pagination.page"
                :page-size="pagination.pageSize"
                @on-change="v=>pagination.page=v"
                @on-page-size-change="v=>pagination.pageSize=v"
                show-elevator
                show-sizer
                transfer
            />
        </div>
    </div>
    <!-- </Scroll> -->
</template>

<script>
import { mapState, mapMutations } from "vuex";
import api from "@/api/Api";
import extend from "extend";
import apimodel from "@/model/ApiModel";
import helper from "@/assets/helper.js";
import PrettyText from "@/components/PrettyText";
import Preview from "@/components/VideoPreviewDialog";
import PicturePreviewDialog from "@/components/PicturePreviewDialog";
import PrettyImage from "@/components/PrettyImage";
import logger from "@/assets/log";
import Uploader from "@/components/upload/upload";
import HtmlDecode from "@/plugins/htmlDecode";

const log = logger("views:material:all");

let { Const } = apimodel;

export default {
    props: ['id', 'topicUid'],
    components: {
        PrettyText,
        Preview,
        PicturePreviewDialog,
        PrettyImage,
        Uploader
    },
    mixins: [
        {
            methods: helper
        }
    ],
    data() {
        return {
            Const,
            // boxHeight: 300,
            dialog: false,
            dialog_loading: false,
            upload_dialog: false,
            show_viewer: false,
            show_player: false,
            viewerMaterial: null,
            playerMaterial: null,
            show_download_dialog: false,
            download_dialog: {},
            loading: true,
            list: [],
            materialSettings: {
                id: 0,
                name: '',
                imgUrl:'',
                type:0,
                status:0
            },
            uploadServer: {
                softwareId: null,
                uploadServerUrl: null,
                uploadServerId: null
            }
        };
    },
    computed: {
        filter: {
            get() {
                return this.$store.state.views.material.all.filter;
            },
            set(v) {
                this.$store.commit("views/material.all.filter", v);
            }
        },
        pagination: {
            get() {
                return this.$store.state.views.material.all.pagination;
            },
            set(v) {
                this.$store.commit("views/material.all.pagination", v);
            }
        },
        ...mapState({
            userId: state => state.user.id,
            uploaderLoading: state =>
                state.uploader.UploadServer.loadingStatus == "loading",
            uploaderReady: state =>
                state.uploader.UploadServer.loadingStatus == "done",
            uploaderResult: state => state.uploader.newMaterialStatus,
            globalConfig: state => state.user.globalConfig,
            config: state => state.config
        }),
        uploadMaxSize() {
            switch(this.filter.type) {
                case Const.Material.Type.Video:
                    return this.$store.getters['uploader/videoMaxSize'](this.$store.state.config.uploadVideoLimit);
                case Const.Material.Type.Audio:
                    return this.$store.getters['uploader/audioMaxSize'](this.$store.state.config.uploadAudioLimit);
                case Const.Material.Type.Image:
                    return this.$store.getters['uploader/imageMaxSize'](this.$store.state.config.uploadImageLimit);
            }
            return 0;
        },
        imgSrc(){
            return function (p) {
                switch (p.type){
                    case Const.Material.Type.Audio:
                        return 'music';
                    case Const.Material.Type.Video:
                        return p.videoImagePath;
                    case Const.Material.Type.Image:
                        return p.filePath;
                }
            }
        },
        publishing(){
            return function (publishStatus) {
                switch (publishStatus){
                    case Const.Material.PublishStatus.Init:
                        return false;
                    case Const.Material.PublishStatus.Defeated:
                        return false;
                    case Const.Material.PublishStatus.Issue:
                        return false;
                    case Const.Material.PublishStatus.Uploading3:
                        return true;
                    case Const.Material.PublishStatus.Uploading4:
                        return true;
                    case Const.Material.PublishStatus.Publishing:
                        return true;
                }
            }
        }
    },
    watch: {
        'filter.name'() {
            if(this.containsInvaildChar(this.filter.name)) {
                return;
            }
            this.pagination.page = 1;
            this.refresh();
        },
        'filter.type'() {
            this.pagination.page = 1;
            this.refresh();
		},
        "pagination.page"() {
            this.refresh();
        },
        "pagination.pageSize"() {
            this.refresh();
        },
        uploaderResult(val) {
            let item = val[val.length - 1];
            if (!item.status) {
                this.pagination.page == 1 && this.refresh();
            } else {
                // ignore
            }
        }
    },
    methods: {
        showPreview(p) {
            switch (p.type) {
                case Const.Material.Type.Image:
                    this.viewerMaterial = p.filePath;
                    this.show_viewer = true;
                    break;
                case Const.Material.Type.Video:
                case Const.Material.Type.Audio:
                    this.playerMaterial = p;
                    this.show_player = true;
                    break;
            }
        },
        _videoQuality(i) {
            let p = i.videoDimension
                ? (i.videoDimension + "x").split("x")[1]
                : "";
            p = +p ? p + "P" : "";

            return i.videoLevelName + " " + p;
        },
        async showUploader(){
            this.upload_dialog = true;
            try {
                let ret = await api.call("material/info", {
                    id: 0
                });

                this.uploadServer = ret.uploadJson;
                this.$store.dispatch("uploader/getFileMaxSizes", ret.uploadJson.uploadServerUrl);
            } catch (e) {
                // ignore
            }
        },
        async getDownload(id){
            try {
                let ret = await api.call("material/getDownloadUrl", {
                    id: id
                });

                window.open(ret.downloadUrl)
            } catch (e) {
                this.$Notice.error({ title: this.$t('Message.download.error') });
            }
        },
        edit(id, name) {
            event.stopPropagation();
            this.dialog = true;
            this.materialSettings.id = id;
            this.materialSettings.name = name;
        },
        async save(){
            if(this.materialSettings.name == ""){
                this.$Message.info(this.$t('MaterialManagement.Material.message.nameEmpty'))
            }else {
                try {
                    await api.call("material/save", this.materialSettings);

                    this.$Notice.success({ title: this.$t('Message.save.success') });

                    this.dialog = false;
                    this.refresh();
                } catch (e) {
                    this.$Notice.error({ title: this.$t('Message.save.error') });
                }
            }
        },
        async remove(id, title) {
            if (!confirm(this.$t('Message.remove.confirm') + `(${title}) ?`)) return;

            this.loading = true;

            try {
                let ret = await api.call("material/delete", {
                    id: id
                });

                this.$Notice.success({ title: this.$t('Message.remove.success') + `(${title})` });

                this.refresh();
            } catch (e) {
                this.$Notice.error({ title: this.$t('Message.remove.error') + `(${title})`, desc: e.resultMsg });
            }
            this.loading = false;
        },
        async publish(id, publishStatus){
            if(publishStatus == Const.Material.PublishStatus.Init){
                if (!confirm(this.$t('MaterialManagement.Material.message.publish.confirm'))) return;
            }
            if(publishStatus == Const.Material.PublishStatus.Issue){
                if (!confirm(this.$t('MaterialManagement.Material.message.publish.confirmAgain'))) return;
            }

            this.loading = true;

            try {
                await api.call("material/publishVideoMaterial", {
                    id: id
                });

                this.refresh();
            } catch (e) {
                // ignore
            }
            this.loading = false;
        },
        async refresh(withoutLoading) {
            !withoutLoading && (this.loading = true);

            try {
                this.filter.topicId = this.id;
                let param = extend(true, {}, this.pagination, this.filter, {
                    // type: this.type
                });
                let ret = await api.call("material/list", param);
                // decode name if ret.list is valid
                if (ret.list && ret.list.length) {
                    ret.list.forEach(item => {
                        item.name = HtmlDecode.d(item.name);
                    });
                }
                this.list = ret.list;
                this.pagination.total = ret.total;
            } catch (e) {
				this.$Notice.error({
					title: this.$t(e && e.reject ?
						'Message.permission.error' :
						'Message.callResult.retry')
				});
				this.list = [];
				this.pagination.total = 0 ;
            }

            this.loading = false;

            !withoutLoading &&
                this.$nextTick(() => {
                    this.$refs.list.parentElement.parentElement.parentElement.scrollTo(
                        0,
                        0
                    );
                });
        },
        //更新状态
        async refreshStatus() {
            if(this.hasPermission('opMaterialInfo')){
                try {
                    let ids = this.list.map(i => i.id);

                    if (!ids.length) return;

                    let ret = await api.call("material/refreshData", { ids });

                    let needRefresh = false;
                    this.list = this.list.map(i => {
                        //在返回的列表里面搜索对应的 id
                        let found = ret.list.filter(j => j.id == i.id)[0];
                        if (found) {
                            //如果从转码完成，则刷新列表
                            if (i.status != Const.Material.Status.Done && found.status == Const.Material.Status.Done) {
                                needRefresh = true;
                            }
                            //如果发布完成，则刷新列表
                            if(i.publishStatus != Const.Material.PublishStatus.Issue && found.publishStatus == Const.Material.PublishStatus.Issue){
                                needRefresh = true;
                            }
                            //当视频封面图生成后，刷新列表
                            if (i.type === 1) {
                                if (!i.videoImagePath && found.videoImagePath) {
                                    needRefresh = true;
                                }
                            }
                            //更新 status
                            i.status = found.status;
                            i.publishStatus = found.publishStatus;
                            i.finishRate = found.finishRate;
                        }
                        return i;
                    });
                    needRefresh && this.refresh(true);
                } catch (e) {
                    console.log(e)
                }
            }
        }
    },
    mounted() {
        this.refresh();
        this._statusTmr = setInterval(this.refreshStatus, 2000);
    },
    created() {},
    beforeDestroy() {
        clearInterval(this._statusTmr);
    }
};
</script>

<style lang="less" scoped>
@keyframes spin1 {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}
.box {
}
.header {
    & > * {
        margin-bottom: 10px;
        border-radius: 5px;
    }
    .toolbar {
        height: 32px;
        line-height: 32px;

        button {
            margin-right: 22px;
            vertical-align: middle;
        }

        .search {
            width: 200px;
        }
    }
}
.content {
    position: relative;
    border-radius: 5px;
    background: white;
    padding: 0 20px;

    .spin {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
}
.list {
    list-style: none;
    padding: 0 7px;
    border-radius: 5px;
    background: white;

    .item {
        border-bottom: 1px solid #e9e9e8;
        /*height: 140px;*/
        height: 100%;
        padding: 15px 0px;
        white-space: nowrap;
        position: relative;
        overflow: hidden;
        & > * {
            height: 100%;
            display: inline-block;
            vertical-align: middle;
        }

        .title-tag {
            border-radius: 5px;
            font-size: 12px;
            background: #e3e3e3;
            padding: 2px;
        }
        .item-thumb {
            height: 90px;
            // 如果设置 line-height: 90px 内容会下移1px，原因不明
            line-height: 89px;
            width: 160px;
            border-radius: 5px;
            overflow: hidden;
            margin-right: 12px;
            position: relative;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                vertical-align: middle;
                border: 0;
            }
            canvas {
                width: 100%;
                border: 0;
                vertical-align: middle;
            }
            .view {
                width: 160px;
                height: 90px;
                position: absolute;
                top: 0;
                left: 0;
            }
            .view:hover {
                cursor: pointer;
                background: rgba(0, 0, 0, 0.3);
            }
            .view-icon {
                visibility: hidden;
                position: absolute;
                left: 50%;
                top: 50%;
                margin: -12px 0 0 -12px;
                color: #ffffff;
                z-index: 1000;
            }
            .view:hover .view-icon {
                visibility: visible;
            }
            .view:hover .play-btn {
                visibility: visible;
            }
            .play-btn {
                visibility: hidden;
                width: 40px;
                height: 40px;
                font-size: 30px;
                position: absolute;
                cursor: pointer;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
                background: rgba(255, 255, 255, 0.5);
                box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 10px;
                border-radius: 40px;
                i {
                    width: 100%;
                    height: 100%;
                    line-height: 40px;
                    text-align: center;
                    vertical-align: top;
                    padding-left: 5px;
                }
            }
            .play-btn:hover {
                background: #fff;
            }
        }
        .item-info {
            & > .title {
                font-size: 15px;
                color: #666;
                & > * {
                    vertical-align: middle;
                }
                a {
                    margin-left: 5px;
                }
            }
            .list {
                color: #989898;
                list-style: none;
                margin: 0;
                padding: 0;
                line-height: 19px;

                .title {
                    width: 60px;
                    display: inline-block;
                }
                .title:after {
                    content: ":";
                }
                .video-level-tag {
                    border-radius: 2px;
                    margin-right: 5px;
                    border-bottom: 1px dashed #e3e3e3;
                    cursor: pointer;
                }
                .video-level-tag:after {
                    content: "、";
                }
                .video-level-tag:last-child:after {
                    content: "";
                }
            }
        }
        .item-op {
            position: absolute;
            right: 0;
            height: auto;
            width: 200px;
            background: white;
            text-align: right;
            white-space: normal;
            .delete_btn2 {
                display: none;
            }
        }
    }
}
.pager {
    text-align: center;
    padding: 10px;
}

@media only screen and (max-width: 1440px) {
    .list .item .item-info > .title a {
        width: 80%;
    }
}

@media all and (orientation: portrait), all and (max-width: 1024px) {
    .list .item .item-op {
        background: transparent;
        .edit_btn {
            display: none;
        }
        .download_btn {
            display: none;
        }
        .delete_btn {
            display: none;
        }
        .delete_btn2 {
            display: inline-block;
        }
        bottom: 10px;
    }
    .list .item .item-thumb {
        width: 60px;
    }
    .content {
        padding: 0;
    }
}
</style>